import { ApiService } from "./api.service";

export default class NotificationService extends ApiService {
  namespace = "notifications";
  relations = "?expand=people,people.display_name";
  icon = "Tick";
  
  DOMAIN = -73;
  favicon = "Tick";
  Width = 990;
  action = "action";
  singular = this.terminology.notification.singular;
  plural = this.terminology.notification.plural;
  vowel = this.terminology.notification.vowel;
  name = `${this.vowel} ${this.singular}`;
  constructor() {
    super("notifications");
  }
}
